<template>
  <div>
    <vxe-card>
      <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
    </vxe-card>
    <inspection-config ref="inspectionConfig" :inspection-types="inspectionTypes"/>
    <picking-mode-config ref="pickingModeConfig" :order-properties="orderProperties" :picking-modes="pickingModes"/>
    <automation-config ref="automationConfig" :pickup-modes="pickupModes" :regions="regions"/>
    <distribution-container-config ref="distributionContainerConfig" :container-types="containerTypes" :distribution-types="distributionTypes" :flow-types="flowTypes" :pack-types="packTypes"/>
    <conveyor-config ref="conveyorConfig" :conveyors="conveyors" :directions="directions" :pickup-modes="pickupModes"/>
  </div>
</template>
<script>
import InspectionConfig from '@/views/basedata/warehouse/InspectionConfig.vue'
import PickingModeConfig from '@/views/basedata/warehouse/PickingModeConfig.vue'
import AutomationConfig from '@/views/basedata/warehouse/AutomationConfig.vue'
import DistributionContainerConfig from '@/views/basedata/warehouse/DistributionContainerConfig.vue'
import ConveyorConfig from '@/views/basedata/warehouse/ConveyorConfig.vue'

export default {
  name: 'WarehouseExtra',
  components: { InspectionConfig, PickingModeConfig, AutomationConfig, DistributionContainerConfig, ConveyorConfig },
  props: {
    pickupModes: { type: Array, default: [] },
    regions: { type: Array, default: [] },
    orderProperties: { type: Array, default: [] },
    inspectionTypes: { type: Array, default: [] },
    pickingModes: { type: Array, default: [] },
    flowTypes: { type: Array, default: [] },
    packTypes: { type: Array, default: [] },
    distributionTypes: { type: Array, default: [] },
    containerTypes: { type: Array, default: [] },
    conveyors: { type: Array, default: [] },
    directions: { type: Array, default: [] }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    refresh(warehouse) {
      this.$refs.inspectionConfig.refresh(warehouse)
      this.$refs.pickingModeConfig.refresh(warehouse)
      this.$refs.automationConfig.refresh(warehouse)
      this.$refs.distributionContainerConfig.refresh(warehouse)
      this.$refs.conveyorConfig.refresh(warehouse)
    }
  }
}
</script>